import { api } from 'infra/adapters/http-client-adapter'

export const endRequest = async (params) => {
  return await api.post('/v01/pedidos/FinalizaPedidos', params)
}
